import React, { useState } from 'react';
import Layout from '../components/layout';
import Cta from '../components/HomePage/Cta';
import AppLink from '../components/HomePage/AppLink';
import classes from '../styles/contactus.module.css';
import FormInput from '../components/Forms/FormInput';
import FormButton from '../components/Forms/FormButton';
import FormTextArea from '../components/Forms/FormTextArea';
import Link from 'next/link';
import FormErrors from '~src/components/Forms/FormErrors';
import ContactUsFormValidation from '~src/components/Forms/ContactUsFormValidation';
import { contactUs } from '../helpers/api-utils';
import Notification from "../components/ui/Notification";
import { useRouter } from 'next/router';
import { useIntl } from 'react-intl';

function Contactus() {
    const { locale } = useRouter();
    const intl = useIntl();

    const contact = intl.formatMessage({ id: "contact-contact"})
    const us = intl.formatMessage({ id: "contact-us"})
    const contact_text = intl.formatMessage({ id: 'contact-text'})    
    const contact_us_email = intl.formatMessage({ id: 'contact-us-email'})
    const getintouch = intl.formatMessage({ id: 'contact-getintouch'})
    const send_message = intl.formatMessage({ id: 'contact-send-message'})
    const contact_fullname = intl.formatMessage({ id: 'contact-fullname'})
    const contact_email_address = intl.formatMessage({ id: 'contact-email-address'})
    const contact_typing = intl.formatMessage({ id: 'contact-typing'})

    const [formError, setFormError] = useState({
        email: "",
        name: "",
        text: ""
    });
    const [notification, setnotification] = useState({ open: false, loading: false, message: "", error: false });

    const HandleFormSubmit = async (e: React.SyntheticEvent) => {
        e.preventDefault();

        const target = e.target as typeof e.target & {
            email: { value: string };
            name: { value: string };
            text: { value: string };
        };

        const email = target.email.value; // typechecks!
        const name = target.name.value; // typechecks!
        const text = target.text.value; // typechecks!

        const { errors, condition } = ContactUsFormValidation({
            email: email,
            name: name,
            text: text
        });

        if (condition === false) {
            setFormError(errors);
            return;
        } else if (condition === true) {
            setFormError(errors);
        }

        try {
            const result = await contactUs({
                name: name,
                email: email,
                body: text
            })

            if (result.data === true && result.error === null) {
                setnotification({ open: true, loading: false, message: "Your form submitted successfully.", error: false })
                setTimeout(() => {
                    setnotification({ open: false, loading: false, message: "Your form submitted successfully.", error: false })
                }, 2000)
                const formEl = window.document.getElementById('contactForm')
                formEl?.reset()
            } else {
                setnotification({ open: true, loading: false, message: result.message, error: true })
                setTimeout(() => {
                    setnotification({ open: false, loading: false, message: result.message, error: true })
                }, 3000)
            }
        } catch (error) {
            console.error(error);
            setnotification({ open: true, loading: false, message: error.message, error: true });
            setTimeout(() => {
                setnotification({ open: false, loading: false, message: error.message, error: true })
            }, 3000)
        }
    }

    return (
        <Layout>
            <Notification notification={notification} setnotification={setnotification} error={notification.error} />
            <section className={classes.contactus_section}>
                <div className={classes.contactus_heading}>
                    <div className={classes.container}>
                        <div 
                            className={classes.row} 
                            style={{flexDirection: locale === 'ar' ? 'row-reverse' : 'row'}}
                        >
                            <div 
                                className={classes.col12_md10_lg6}
                                style={{textAlign: locale === 'ar' ? 'end' : 'start'}}
                            >
                                <h1>{contact} <span className={classes.us_word}> {us}</span></h1>
                                <p>{contact_text}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classes.contact_info_section}>
                    <div className={classes.container}>
                        <div 
                            className={classes.row}
                            style={{flexDirection: locale === 'ar' ? 'row-reverse' : 'row'}}
                        >
                            <div 
                                className={classes.col12_lg7}
                                style={{textAlign: locale === 'ar' ? 'end' : 'start'}}
                            >
                                <Link href="mailto:contact@sketshare.com" passHref={true}>
                                    <p className={classes.email_text}>contact@sketshare.com</p>
                                </Link>
                                <p>{contact_us_email}
                                </p>
                            </div>
                            {/* <div className='col-12 col-md-12 col-lg-6'></div> */}
                            <div className={classes.col12_lg6}>
                                <div 
                                    className={classes.getInTouchForm}
                                    style={{textAlign: locale === 'ar' ? 'end' : 'start'}}
                                >
                                    <h2>{getintouch}</h2>
                                    <form onSubmit={HandleFormSubmit} id="contactForm">
                                        <FormInput style={{textAlign: locale === 'ar' ? 'end' : 'start'}} type='text' name="name" placeholder={contact_fullname} />
                                        <FormErrors error={formError.name} />
                                        <FormInput style={{textAlign: locale === 'ar' ? 'end' : 'start'}} type='email' name="email" placeholder={contact_email_address} />
                                        <FormErrors error={formError.email} />
                                        <FormTextArea style={{textAlign: locale === 'ar' ? 'end' : 'start'}} name="text" placeholder={contact_typing} />
                                        <FormErrors error={formError.text} />
                                        <FormButton type='submit' title={send_message} />
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Cta />
                {/* <AppLink /> */}
            </section>
        </Layout>
    )
}

export default Contactus;